import React, { useCallback } from "react";
import styles from "./HorizontalMenu.module.scss";
import cx from "classnames";

interface Item {
  value: string;
  label: string | React.ReactNode;
}

interface Props {
  items: Item[];
  value: string;
  onChange: (value: string, item: Item) => void;
}
export default function HorizontalMenu({ items, value, onChange }: Props) {
  const onMenuChange = useCallback(
    (value: string, item: Item) => () => onChange(value, item),
    [onChange]
  );
  return (
    <div className={cx(styles.section)}>
      {items.map((item, index) => (
        <>
          {index !== 0 && <span className={cx(styles.pipeSymbol)}>{"|"}</span>}
          <div
            className={cx(
              styles.nameMenu,
              value === item.value ? styles.active : styles.inactive
            )}
            onClick={onMenuChange(item.value, item)}
          >
            {item.label}
          </div>
        </>
      ))}
    </div>
  );
}
